import Cover from "@/containers/Episode/partials/Cover";
import { useI18n } from "@/contexts/i18nContext";
import Typography from "@components/Typography";

import { ImpactScoreData } from "../types";

import styles from "../ImpactScore.module.css";

const Info = ({ channel, mention_count }: ImpactScoreData) => {
  const { formatNumber } = useI18n();
  return (
    <div className={styles.info}>
      <header>
        <Cover
          className={styles.cover}
          episode={{
            source: channel.channel_type,
            cover: channel.artwork_url,
          }}
          dumb
        />

        <div>
          <Typography
            margin="none"
            variant="caption"
            block
            className={styles.channelName}
          >
            {channel.name}
          </Typography>
          <Typography margin="none" variant="body-2" block>
            {L.REPORTS_WIDGET_REACH_TABLE_REACH}
            {": "}
            {formatNumber(channel.current_reach)}
          </Typography>
          <Typography margin="none" variant="body-2" block>
            {L.REPORTS_WIDGET_REACH_TABLE_MENTIONS}
            {": "}
            {formatNumber(mention_count)}
          </Typography>
        </div>
      </header>
      {channel.description && (
        <div className={styles.description}>
          <Typography
            variant="body-2"
            block
            className={styles.descriptionInner}
          >
            {channel.description}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default Info;
